/* eslint-disable react/jsx-props-no-spreading */
import React, { createRef, useContext } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { ArrowBack, Info } from '@material-ui/icons';
import {
  AgGridWidgetWrapper,
  AppContent,
  AppRoot,
  HeightProvider,
  TopBar,
} from '@mummssoftware/common-ui';
import { Route, Switch } from 'react-router-dom';
import defaults from '../../translations/en.json';
import { QuickSearch } from '../PatientPortal/QuickSearch';
import PatientPortalComponent from '../PatientPortal/index';
import { usePortalNav } from '../PatientPortal/usePortalNav';
import {
  NavContextProvider,
  PortalNavContext,
} from '../PortalNavContext/PortalNavContext';
import { LISTING, PATIENT } from '../PortalNavContext/constants';

const PatientPortalTopBar = ({ headerRef, currentUser, logout }: any) => {
  const { page } = useContext(PortalNavContext);
  const { openListing } = usePortalNav();

  return (
    <TopBar
      ref={headerRef}
      title={
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.5vw',
          }}
        >
          {defaults.title}
          {page === LISTING && (
            <Tooltip title="This is a read-only application; your access to patients is configurable in PIM.">
              <Info />
            </Tooltip>
          )}
          {page === PATIENT && (
            <IconButton onClick={openListing} size="small">
              <ArrowBack />
            </IconButton>
          )}
          {/* <QuickSearch /> */}
        </div>
      }
      disableSitePicker
      currentUser={currentUser}
      logout={logout}
    />
  );
};

type BaseAppProps = {
  embedded?: boolean;
  smallWidget?: boolean;
  appTitle?: string;
  currentUser: mumms.User;
  patientsList: mumms.patient[];
  online?: boolean;
  logout?: () => void;
  onClick?: () => void;
  viewMode?: mumms.viewMode;
  onWidgetReady?: (arg: mumms.ComponentName) => void;
};

const mainPaths = ['/'];

const App = ({
  embedded,
  currentUser,
  smallWidget,
  patientsList,
  online,
  logout,
}: BaseAppProps) => {
  const headerRef = createRef<HTMLElement>();

  return (
    <AppRoot embedded={embedded}>
      <NavContextProvider>
        {/* if not embedded in dashboard show a top bar when in stand alone mode */}
        {!embedded && (
          <PatientPortalTopBar
            headerRef={headerRef}
            currentUser={currentUser}
            logout={logout}
          />
        )}

        <HeightProvider passedRef={headerRef}>
          {(height: any) => (
            <AppContent height={height} embedded={embedded}>
              <Switch>
                <AgGridWidgetWrapper
                  id="patient-portal-body"
                  smallWidget={smallWidget}
                >
                  {patientsList ? (
                    <Route
                      path={mainPaths}
                      render={(props: any) => (
                        <PatientPortalComponent
                          embedded={embedded}
                          currentUser={currentUser}
                          patientsList={patientsList}
                          online={online}
                          smallWidget={smallWidget}
                          {...props}
                        />
                      )}
                    />
                  ) : null}
                </AgGridWidgetWrapper>
              </Switch>
            </AppContent>
          )}
        </HeightProvider>
      </NavContextProvider>
    </AppRoot>
  );
};

export default App;
